<template>
	<v-card 
		flat
		color="secondary"
	>
		<v-data-table
			:items="totalExpenses"
			class="elevation-1"
			hide-actions
			hide-headers
		>
			<template v-slot:items="props">
				<td class="table">
					{{ props.item.name }}
				</td>
				<td 
					class="text-xs-right table"
				>
					{{ props.item.cost }}
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
export default {
	props: ['fixedExpenses'],
	data () {
		return {

		}
	},

	computed: {
		totalExpenses () {
			const total = this.fixedExpenses.reduce ((total, expense) => {
				return total += parseFloat (expense.cost.replace (',','.'))
			}, 0) 
			return [
				...this.fixedExpenses,
				{'name':'Total','cost':total}
			]
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.table {
	background-color: $secondary;
}

</style>